exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".results {\n  border-radius: 3px;\n  width: 100%;\n  padding: 2%;\n  margin-top: 3%;\n  background-color: #CCCCCC;\n}\n\n.mainresults {\n  padding: 1%;\n}\n\n.results-income{\n  width: 95%;\n}\n\n.left-results {\n  float: left;\n  width: 50%;\n  margin-bottom: 3%;\n}\n.right-results {\n  float: right;\n  width: 50%;\n  margin-bottom: 3%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader!./app/css/calc_income.css
// module id = 239
// module chunks = 0